<template>
  <header
    class="header-expanded pt-4 pb-4 px-4 relative box-border w-full bg-transparent"
  >
    <div
      class="flex items-start"
      :class="[avatarUrl ? 'justify-between' : 'justify-end']"
    >
      <img
        v-if="avatarUrl"
        class="h-16 w-16 mb-4 rounded-full object-cover"
        :src="avatarUrl"
        alt="Avatar"
      />
      <header-actions
        :show-popout-button="showPopoutButton"
        :show-end-conversation-button="false"
      />
    </div>

    <CsText variant="heading-xl" weight="semibold">
      <span v-dompurify-html="introHeading" />
    </CsText>

    <CsText variant-color="secondary" class="mt-2">
      <span v-dompurify-html="introBody" />
    </CsText>
  </header>
</template>

<script>
import HeaderActions from './HeaderActions.vue';
import darkModeMixin from 'widget/mixins/darkModeMixin.js';
import { CsText } from 'dashboard/components/ui/commslayer';

export default {
  name: 'ChatHeaderExpanded',
  components: {
    HeaderActions,
    CsText,
  },
  mixins: [darkModeMixin],
  props: {
    avatarUrl: {
      type: String,
      default: '',
    },
    introHeading: {
      type: String,
      default: '',
    },
    introBody: {
      type: String,
      default: '',
    },
    showPopoutButton: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
